import "./ServicesSection.css";
import SpaceDesign from "../../assets/img/service-images/Space-Design.png";
import Personalised from "../../assets/img/service-images/Personalised-Gifts.png";
import Garlands from "../../assets/img/service-images/garlends.png";
import Wedding from "../../assets/img/service-images/Wedding Decoration.png";
export default function ServicesSection() {
  return (
    <section className="pb-4 mt-4 section-spacing-x">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6">
            <div className="row home-service">
              <div className="col-lg-6 col-6 mb-4">
                {/* <div className="services-card"> */}
                <img
                  src={SpaceDesign}
                  alt="Space Design"
                  className="img-fluid"
                />
                {/* <h3>Space Design</h3>
                </div> */}
              </div>
              <div className="col-lg-6 col-6 mb-4">
                {/* <div className="services-card"> */}
                <img
                  src={Personalised}
                  alt="Personalised Gifts and Trousseau Packing"
                  className="img-fluid"
                />
                {/* <h3>
                    Personalised Gifts */}
                {/* and Trousseau Packing */}
                {/* </h3> */}
                {/* </div> */}
              </div>
              <div className="col-lg-6 mb-4 col-6 mb-lg-0">
                {/* <div className="services-card"> */}
                <img
                  src={Wedding}
                  alt="Wedding Decoration"
                  className="img-fluid"
                />
                {/* <h3>Wedding Decoration</h3> */}
                {/* </div> */}
              </div>
              <div className="col-lg-6 mb-4 col-6 mb-lg-0">
                {/* <div className="services-card"> */}
                <img
                  src={Garlands}
                  alt="Garlands and Bouquet"
                  className="img-fluid"
                />
                {/* <h3>Garlands and Bouquet</h3> */}
                {/* </div> */}
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <h2 className="main-heading">Services</h2>
            <p>
              At Floral Hut, we offer a range of services designed to bring
              beauty and elegance to your events and special moments. Our Space
              Design services transform any venue into a stunning floral
              paradise, perfect for celebrations or everyday décor.
            </p>
            <p>
              {" "}
              We also specialize in Personalized Gifts and Trousseau Packing,
              adding a unique, thoughtful touch to your gifting with customized
              floral creations and exquisite packaging.
            </p>{" "}
            <p>
              {" "}
              Our collection of Garlands and Bouquets offers the perfect floral
              arrangements for any occasion, from weddings to daily surprises.
              For those planning their big day, our Wedding Decoration service
              ensures a breathtaking ambiance with beautifully crafted floral
              designs that reflect your vision, making your celebration truly
              unforgettable.
            </p>
            <p>
              {" "}
              At Floral Hut, we ensure every service is crafted with care,
              passion, and a personalized touch.
            </p>
            {/* <a href="/" className="theme-btn">
              Read more
            </a> */}
          </div>
        </div>
      </div>
    </section>
  );
}
